<template>
    <div class="col-12 py-2">
        <div class="w-100 mt-2">
            <h6 class="mb-2 d-flex align-items-center">
                <b class="me-2"> {{ type }} Medicaid</b>
            </h6>
        </div>
    </div>
    <template v-if="type == 'Primary'">
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-member-id" for="referral-member-id">
                Member ID: <span class="text-danger">*</span></label
            >
            <input
                id="referral-member-id"
                name="referral-member-id"
                :class="`form-control ${
                    v$.referral.Insurance.PrimaryHealthPlanId.$error || errors.Insurance.includes('PrimaryHealthPlanId')
                        ? 'border border-warning'
                        : ''
                }`"
                maxlength="50"
                type="text"
                placeholder="Enter Member ID"
                v-model="referral.Insurance.PrimaryHealthPlanId"
                @blurr="v$.referral.Insurance.PrimaryHealthPlanId.$touch"
                @change="(e:any)=>handleAllInput('PrimaryHealthPlanId',e.target.value,'Insurance')"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-group-name" for="referral-group-name"> Group Name: </label>
            <input
                id="referral-group-name"
                name="referral-group-name"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Group Name"
                v-model="referral.Insurance.PrimaryGroupName"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-group-id" for="referral-group-id"> Group ID: </label>
            <input
                id="referral-group-id"
                name="referral-group-id"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Group ID"
                v-model="referral.Insurance.PrimaryGroupId"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="referral-primary-relationship">
                Relationship to Insured: <span class="text-danger">*</span></label
            >
            <select
                :class="`form-select ${
                    v$.referral.Insurance.PrimaryRelationship.$error || errors.Insurance.includes('PrimaryRelationship')
                        ? 'border border-warning'
                        : ''
                }`"
                name="referral-primary-relationship"
                v-model="referral.Insurance.PrimaryRelationship"
                @blur="v$.referral.Insurance.PrimaryRelationship.$touch"
                @change="handleAllInput('PrimaryRelationship', referral.Insurance.PrimaryRelationship, 'Insurance')"
            >
                <option :value="null">Select Option</option>
                <option v-for="status in options?.primaryRelationship" :key="status.value" :value="status.value">
                    {{ status.text }}
                </option>
            </select>
        </div>
        <div
            class="row w-100 ps-3"
            v-if="referral.Insurance.PrimaryRelationship != '2' && referral.Insurance.PrimaryRelationship != null"
        >
            <div class="form-group col-5 col-lg-5 pe-lg-12">
                <label id="Referral-insured-first-name" for="referral-insured-first-name">
                    Insured First Name: <span class="text-danger">*</span></label
                >
                <input
                    id="referral-insured-first-name"
                    name="referral-insured-first-name"
                    :class="`form-control ${
                        v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName.$error ||
                        errors.PrimaryInsuredDetails.includes('FirstName')
                            ? 'border border-warning'
                            : ''
                    }`"
                    maxlength="50"
                    type="text"
                    placeholder="Enter Insured First Name"
                    v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName"
                    @blur="v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName.$touch"
                    @change="(e:any)=>handleAllInput('FirstName', e.target.value, 'PrimaryInsuredDetails')"
                />
            </div>
            <div class="form-group col-2 col-lg-2 pe-lg-12">
                <label id="Referral-insured-mi" for="referral-insured-mi"> Insured MI: </label>
                <input
                    id="referral-insured-mi"
                    name="referral-insured-mi"
                    class="form-control"
                    type="text"
                    placeholder="Enter Insured MI"
                    v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.MiddleInitial"
                />
            </div>
            <div class="form-group col-5 col-lg-5 pe-lg-12 pe-0">
                <label id="Referral-insured-last-name" for="referral-insured-last-name">
                    Insured Last Name: <span class="text-danger">*</span></label
                >
                <input
                    id="referral-insured-last-name"
                    name="referral-insured-last-name"
                    :class="`form-control ${
                        v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName.$error ||
                        errors.PrimaryInsuredDetails.includes('LastName')
                            ? 'border border-warning'
                            : ''
                    }`"
                    maxlength="50"
                    type="text"
                    placeholder="Enter Insured Last Name"
                    v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName"
                    @blur="v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName.$touch"
                    @change="(e:any)=>handleAllInput('LastName', e.target.value, 'PrimaryInsuredDetails')"
                />
            </div>
        </div>

        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-employer-name" for="referral-employer-name"> Employer Name: </label>
            <input
                id="referral-employer-name"
                name="referral-employer-name"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Name"
                v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.EmployerName"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-deductable-amount" for="referral-deductable-amount"> Deductable Amount: </label>
            <input
                id="referral-deductable-amount"
                name="referral-deductable-amount"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Amount"
                v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleAmount"
            />
        </div>

        <div class="col-12 py-2">
            <div class="w-100 my-2">
                <h6 class="mb-2 d-flex align-items-center">
                    <b class="me-2"> Deductable Met</b>
                </h6>
            </div>
            <div class="form-group col-12 col-lg-12 pe-lg-2">
                <div class="form-check custom-radio pb-1 mt-3">
                    <input
                        type="radio"
                        class="form-check-input"
                        id="referral-primary-deductible-yes"
                        name="referral-primary-deductible-yes"
                        v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleMet"
                        value="1"
                    />
                    <label class="form-check-label mb-2" for="referral-primary-deductible-yes"> Yes </label>
                </div>

                <div class="form-check custom-radio pb-1">
                    <input
                        type="radio"
                        class="form-check-input"
                        name="referral-primary-deductible-no"
                        id="referral-primary-deductible-no"
                        v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleMet"
                        value="0"
                    />
                    <label class="form-check-label mb-2" for="referral-primary-deductible-no"> No </label>
                </div>
            </div>
        </div>

        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-copay-amount" for="referral-copay-amount"> Copay Amount: </label>
            <input
                id="referral-copay-amount"
                name="referral-copay-amount"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Amount"
                v-model="referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.CopayAmount"
            />
        </div>
    </template>
    <template v-if="type == 'Secondary'">
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-member-id" for="referral-member-id">
                Member ID: <span class="text-danger">*</span></label
            >
            <input
                id="referral-member-id"
                name="referral-member-id"
                :class="`form-control ${
                    v$.referral.Insurance.SecondaryHealthPlanId.$error ||
                    errors.Insurance.includes('SecondaryHealthPlanId')
                        ? 'border border-warning'
                        : ''
                }`"
                maxlength="50"
                type="text"
                placeholder="Enter Member ID"
                v-model="referral.Insurance.SecondaryHealthPlanId"
                @blur="v$.referral.Insurance.SecondaryHealthPlanId.$touch"
                @change="(e:any)=>handleAllInput('SecondaryHealthPlanId', e.target.value, 'Insurance')"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-group-name" for="referral-group-name"> Group Name: </label>
            <input
                id="referral-group-name"
                name="referral-group-name"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Group Name"
                v-model="referral.Insurance.SecondaryGroupName"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-group-id" for="referral-group-id"> Group ID: </label>
            <input
                id="referral-group-id"
                name="referral-group-id"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Group ID"
                v-model="referral.Insurance.SecondaryGroupId"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="referral-primary-relationship">
                Relationship to Insured: <span class="text-danger">*</span></label
            >
            <select
                :class="`form-select ${
                    v$.referral.Insurance.SecondaryRelationship.$error ||
                    errors.Insurance.includes('SecondaryRelationship')
                        ? 'border border-warning'
                        : ''
                }`"
                name="referral-primary-relationship"
                v-model="referral.Insurance.SecondaryRelationship"
                @blur="v$.referral.Insurance.SecondaryRelationship.$touch"
                @change="handleAllInput('SecondaryRelationship', referral.Insurance.SecondaryRelationship, 'Insurance')"
            >
                <option :value="null">Select Option</option>
                <option v-for="status in options?.secondaryRelationship" :key="status.value" :value="status.value">
                    {{ status.text }}
                </option>
            </select>
        </div>
        <div
            class="row w-100 ps-3"
            v-if="referral.Insurance.SecondaryRelationship != '2' && referral.Insurance.SecondaryRelationship != null"
        >
            <div class="form-group col-5 col-lg-5 pe-lg-12">
                <label id="Referral-insured-first-name" for="referral-insured-first-name">
                    Insured First Name: <span class="text-danger">*</span></label
                >
                <input
                    id="referral-insured-first-name"
                    name="referral-insured-first-name"
                    :class="`form-control ${
                        v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName.$error ||
                        errors.SecondaryInsuredDetails.includes('FirstName')
                            ? 'border border-warning'
                            : ''
                    }`"
                    maxlength="50"
                    type="text"
                    placeholder="Enter Insured First Name"
                    v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName"
                    @blur="v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName.$touch"
                    @change="(e:any)=>handleAllInput('FirstName', e.target.value, 'SecondaryInsuredDetails')"
                />
            </div>
            <div class="form-group col-2 col-lg-2 pe-lg-12">
                <label id="Referral-insured-mi" for="referral-insured-mi"> Insured MI: </label>
                <input
                    id="referral-insured-mi"
                    name="referral-insured-mi"
                    class="form-control"
                    type="text"
                    placeholder="Enter Insured MI"
                    v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.MiddleInitial"
                />
            </div>
            <div class="form-group col-5 col-lg-5 pe-lg-12 pe-0">
                <label id="Referral-insured-last-name" for="referral-insured-last-name">
                    Insured Last Name: <span class="text-danger">*</span></label
                >
                <input
                    id="referral-insured-last-name"
                    name="referral-insured-last-name"
                    :class="`form-control ${
                        v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName.$error ||
                        errors.SecondaryInsuredDetails.includes('LastName')
                            ? 'border border-warning'
                            : ''
                    }`"
                    maxlength="50"
                    type="text"
                    placeholder="Enter Insured Last Name"
                    v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName"
                    @blur="v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName.$touch"
                    @change="(e:any)=>handleAllInput('LastName', e.target.value, 'SecondaryInsuredDetails')"
                />
            </div>
        </div>

        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-employer-name" for="referral-employer-name"> Employer Name: </label>
            <input
                id="referral-employer-name"
                name="referral-employer-name"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Name"
                v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.EmployerName"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-deductable-amount" for="referral-deductable-amount"> Deductable Amount: </label>
            <input
                id="referral-deductable-amount"
                name="referral-deductable-amount"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Amount"
                v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleAmount"
            />
        </div>

        <div class="col-12 py-2">
            <div class="w-100 my-2">
                <h6 class="mb-2 d-flex align-items-center">
                    <b class="me-2"> Deductable Met</b>
                </h6>
            </div>
            <div class="form-group col-12 col-lg-12 pe-lg-2">
                <div class="form-check custom-radio pb-1 mt-3">
                    <input
                        type="radio"
                        class="form-check-input"
                        id="referral-secondary-deductible-yes"
                        name="referral-secondary-deductible-yes"
                        v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleMet"
                        value="1"
                    />
                    <label class="form-check-label mb-2" for="referral-secondary-deductible-yes"> Yes </label>
                </div>

                <div class="form-check custom-radio pb-1">
                    <input
                        type="radio"
                        class="form-check-input"
                        name="referral-secondary-deductible-no"
                        id="referral-secondary-deductible-no"
                        v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleMet"
                        value="0"
                    />
                    <label class="form-check-label mb-2" for="referral-secondary-deductible-no"> No </label>
                </div>
            </div>
        </div>

        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-copay-amount" for="referral-copay-amount"> Copay Amount: </label>
            <input
                id="referral-copay-amount"
                name="referral-copay-amount"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Amount"
                v-model="referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.CopayAmount"
            />
        </div>
    </template>
    <template v-if="type == 'Tertiary'">
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-member-id" for="referral-member-id">
                Member ID: <span class="text-danger">*</span></label
            >
            <input
                id="referral-member-id"
                name="referral-member-id"
                :class="`form-control ${
                    v$.referral.Insurance.TertiaryHealthPlanId.$error ||
                    errors.Insurance.includes('TertiaryHealthPlanId')
                        ? 'border border-warning'
                        : ''
                }`"
                maxlength="50"
                type="text"
                placeholder="Enter Member ID"
                v-model="referral.Insurance.TertiaryHealthPlanId"
                @blur="v$.referral.Insurance.TertiaryHealthPlanId.$touch"
                @change="(e:any)=>handleAllInput('TertiaryHealthPlanId', e.target.value, 'Insurance')"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-group-name" for="referral-group-name"> Group Name: </label>
            <input
                id="referral-group-name"
                name="referral-group-name"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Group Name"
                v-model="referral.Insurance.TertiaryGroupName"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-group-id" for="referral-group-id"> Group ID: </label>
            <input
                id="referral-group-id"
                name="referral-group-id"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Group ID"
                v-model="referral.Insurance.TertiaryGroupId"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="referral-primary-relationship">
                Relationship to Insured: <span class="text-danger">*</span></label
            >
            <select
                :class="`form-select ${
                    v$.referral.Insurance.TertiaryRelationship.$error ||
                    errors.Insurance.includes('TertiaryRelationship')
                        ? 'border border-warning'
                        : ''
                }`"
                name="referral-primary-relationship"
                v-model="referral.Insurance.TertiaryRelationship"
                @blur="v$.referral.Insurance.TertiaryRelationship.$touch"
                @change="handleAllInput('TertiaryRelationship', referral.Insurance.TertiaryRelationship, 'Insurance')"
            >
                <option :value="null">Select Option</option>
                <option v-for="status in options?.tertiaryRelationship" :key="status.value" :value="status.value">
                    {{ status.text }}
                </option>
            </select>
        </div>
        <div
            class="row w-100 ps-3"
            v-if="referral.Insurance.TertiaryRelationship != '2' && referral.Insurance.TertiaryRelationship != null"
        >
            <div class="form-group col-5 col-lg-5 pe-lg-12">
                <label id="Referral-insured-first-name" for="referral-insured-first-name">
                    Insured First Name: <span class="text-danger">*</span></label
                >
                <input
                    id="referral-insured-first-name"
                    name="referral-insured-first-name"
                    :class="`form-control ${
                        v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName.$error ||
                        errors.TertiaryInsuredDetails.includes('FirstName')
                            ? 'border border-warning'
                            : ''
                    }`"
                    maxlength="50"
                    type="text"
                    placeholder="Enter Insured First Name"
                    v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName"
                    @blur="v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName.$touch"
                    @change="(e:any)=>handleAllInput('FirstName',e.target.value, 'TertiaryInsuredDetails')"
                />
            </div>
            <div class="form-group col-2 col-lg-2 pe-lg-12">
                <label id="Referral-insured-mi" for="referral-insured-mi"> Insured MI: </label>
                <input
                    id="referral-insured-mi"
                    name="referral-insured-mi"
                    class="form-control"
                    type="text"
                    placeholder="Enter Insured MI"
                    v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.MiddleInitial"
                />
            </div>
            <div class="form-group col-5 col-lg-5 pe-lg-12 pe-0">
                <label id="Referral-insured-last-name" for="referral-insured-last-name">
                    Insured Last Name: <span class="text-danger">*</span></label
                >
                <input
                    id="referral-insured-last-name"
                    name="referral-insured-last-name"
                    :class="`form-control ${
                        v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName.$error ||
                        errors.TertiaryInsuredDetails.includes('LastName')
                            ? 'border border-warning'
                            : ''
                    }`"
                    maxlength="50"
                    type="text"
                    placeholder="Enter Insured Last Name"
                    v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName"
                    @blur="v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName.$touch"
                    @change="(e:any)=>handleAllInput('LastName',e.target.value, 'TertiaryInsuredDetails')"
                />
            </div>
        </div>

        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-employer-name" for="referral-employer-name"> Employer Name: </label>
            <input
                id="referral-employer-name"
                name="referral-employer-name"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Name"
                v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.EmployerName"
            />
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-deductable-amount" for="referral-deductable-amount"> Deductable Amount: </label>
            <input
                id="referral-deductable-amount"
                name="referral-deductable-amount"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Amount"
                v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleAmount"
            />
        </div>

        <div class="col-12 py-2">
            <div class="w-100 my-2">
                <h6 class="mb-2 d-flex align-items-center">
                    <b class="me-2"> Deductable Met</b>
                </h6>
            </div>
            <div class="form-group col-12 col-lg-12 pe-lg-2">
                <div class="form-check custom-radio pb-1 mt-3">
                    <input
                        type="radio"
                        class="form-check-input"
                        id="referral-tertiary-deductible-yes"
                        name="referral-tertiary-deductible-yes"
                        v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleMet"
                        value="1"
                    />
                    <label class="form-check-label mb-2" for="referral-tertiary-deductible-yes"> Yes </label>
                </div>

                <div class="form-check custom-radio pb-1">
                    <input
                        type="radio"
                        class="form-check-input"
                        id="referral-tertiary-deductible-no"
                        name="referral-tertiary-deductible-no"
                        v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleMet"
                        value="0"
                    />
                    <label class="form-check-label mb-2" for="referral-tertiary-deductible-no"> No </label>
                </div>
            </div>
        </div>

        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label id="Referral-copay-amount" for="referral-copay-amount"> Copay Amount: </label>
            <input
                id="referral-copay-amount"
                name="referral-copay-amount"
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Amount"
                v-model="referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.CopayAmount"
            />
        </div>
    </template>
</template>
<script lang="ts" src="./Medicaid.ts"></script>
